<template>
  <v-container class="pt-0">
    <v-row justify="center">
      <v-dialog
        v-model="open"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Datos de la Carrera</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text color="warning" @click.stop="editDialog">
                <v-icon class="mr-2">mdi-square-edit-outline</v-icon> Editar
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="7">
                      <p class="etiqueta mb-0">Nombre de la carrera</p>
                      <p class="campo">{{ datos.nombre }}</p>
                    </v-col>
                    <v-col cols="7" sm="3">
                      <p class="etiqueta mb-0">Plan de Estudios</p>
                      <p class="campo">{{ datos.plan_estudios }}</p>
                    </v-col>
                    <v-col cols="5" sm="2">
                      <p class="etiqueta mb-0">Vigente</p>
                      <p class="campo">
                        {{ datos.activo == 1 ? "SI" : "NO" }}
                      </p>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <v-divider />
              <v-card class="px-4">
                <v-row>
                  <v-col cols="12">
                    <v-btn
                      color="primary"
                      :small="$vuetify.breakpoint.xs"
                      :x-large="$vuetify.breakpoint.smAndUp"
                      @click.stop="newMateria"
                      >Agregar materia/submódulo</v-btn
                    >
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6" xl="4" v-for="n in 6" :key="n">
                    <v-card>
                      <v-card-title class="primary py-2" style="color: white"
                        >Semestre {{ n }}</v-card-title
                      >
                      <v-card-text>
                        <v-list>
                          <v-list-item
                            link
                            v-for="subitem in semestreNo(n)"
                            :key="subitem.id"
                            @click.stop="editMateria(subitem.id)"
                            >{{ subitem.nombre }}</v-list-item
                          >
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="deleteDlg" persistent max-width="500">
        <v-card>
          <v-card-title class="headline"> Confirma Eliminación </v-card-title>
          <v-card-text
            >Por favor confirma que deseas eliminar el registro de esta
            Carrera.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="deleteDlg = false"> Cancelar </v-btn>
            <v-btn color="red darken-1" text @click="deleteDialog">
              Eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Carrera",

  components: {},

  props: {
    open: Boolean,
    datos: Object,
    subdatos: Object,
  },

  data: () => ({
    dialog: false,
    deleteDlg: false,
  }),

  computed: {
    btnSize() {
      let size = "";
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          size = "x-small";
        case "sm":
          size = "small";
        case "md":
          size = "";
        case "lg":
          size = "large";
        case "xl":
          size = "x-large";
      }
      return { size: true };
    },
  },

  methods: {
    editDialog() {
      this.$emit("edit");
    },

    closeDialog() {
      this.$emit("exit");
    },

    deleteDialog() {
      this.deleteDlg = false;
      this.$emit("delete");
    },

    editMateria(id) {
      this.$emit("materia", id);
    },

    newMateria() {
      this.$emit("new");
    },

    saveDialog() {
      this.$emit("save");
    },

    semestreNo(no) {
      if (this.subdatos) {
        let items = this.subdatos;
        let list = [];
        let result = Object.keys(items).map(function (key) {
          if (items[key].semestre == no) list.push(items[key]);
          return items[key].semestre == no;
        });
        return list;
      } else return null;
    },
  },

  mounted() {},
};
</script>

<style>
.etiqueta {
  font-size: 0.85em;
}
.campo {
  font-size: 1.15em;
  font-weight: 700;
}
</style>